module.exports = __webpack_public_path__ + "static/media/roof.8e4ea91a.png";